<div class="nav_container" *ngIf="logged == 'true' && profil == 1">
  <!--  Side Bar Pour Profil Maimouna Eleve -->
  <div>
    <ul>
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Outils
        </li>
        <li>
          <a
            [routerLink]="['elab']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="66"
              height="66"
              viewBox="0 0 66 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="atom-02">
                <path
                  id="Icon"
                  d="M47.0669 42.235C46.3225 43.0767 45.5413 43.9078 44.7244 44.7247C32.9111 56.5381 18.1108 60.8911 11.6672 54.4474C7.24958 50.0298 7.90655 41.6845 12.563 33.0667M18.9463 23.9945C19.721 23.1136 20.536 22.2441 21.3899 21.3902C33.2033 9.57682 48.0035 5.22382 54.4472 11.6675C58.8678 16.0881 58.2069 24.4419 53.5417 33.066M44.7244 21.3902C56.5378 33.2035 60.8908 48.0038 54.4472 54.4474C48.0035 60.8911 33.2033 56.5381 21.3899 44.7247C9.57655 32.9113 5.22354 18.1111 11.6672 11.6675C18.1108 5.22381 32.9111 9.57682 44.7244 21.3902ZM35.7499 33C35.7499 34.5188 34.5187 35.75 32.9999 35.75C31.4811 35.75 30.2499 34.5188 30.2499 33C30.2499 31.4812 31.4811 30.25 32.9999 30.25C34.5187 30.25 35.7499 31.4812 35.7499 33Z"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">E-Lab</span>
          </a>
        </li>
        <li class="mb-4">
          <a
            [routerLink]="['tableau-bord']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="35"
              height="34"
              viewBox="0 0 35 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="dataflow-03">
                <path
                  id="Icon"
                  d="M16.25 6.37504H26.5917C28.1785 6.37504 28.9719 6.37504 29.578 6.68386C30.1111 6.9555 30.5445 7.38894 30.8162 7.92207C31.125 8.52815 31.125 9.32156 31.125 10.9084V12.75C31.125 14.0702 31.125 14.7303 30.9093 15.251C30.6218 15.9452 30.0702 16.4968 29.3759 16.7844C28.8552 17 28.1952 17 26.875 17M19.0833 27.625H8.74167C7.15485 27.625 6.36144 27.625 5.75536 27.3162C5.22223 27.0446 4.78879 26.6111 4.51715 26.078C4.20833 25.4719 4.20833 24.6785 4.20833 23.0917V21.25C4.20833 19.9299 4.20833 19.2698 4.42401 18.7491C4.71157 18.0549 5.26315 17.5033 5.9574 17.2157C6.47808 17 7.13817 17 8.45833 17M15.2583 20.5417H20.075C20.4717 20.5417 20.6701 20.5417 20.8216 20.4645C20.9549 20.3966 21.0632 20.2882 21.1311 20.155C21.2083 20.0034 21.2083 19.8051 21.2083 19.4084V14.5917C21.2083 14.195 21.2083 13.9967 21.1311 13.8451C21.0632 13.7118 20.9549 13.6035 20.8216 13.5356C20.6701 13.4584 20.4717 13.4584 20.075 13.4584H15.2583C14.8616 13.4584 14.6633 13.4584 14.5118 13.5356C14.3785 13.6035 14.2701 13.7118 14.2022 13.8451C14.125 13.9967 14.125 14.195 14.125 14.5917V19.4084C14.125 19.8051 14.125 20.0034 14.2022 20.155C14.2701 20.2882 14.3785 20.3966 14.5118 20.4645C14.6633 20.5417 14.8616 20.5417 15.2583 20.5417ZM25.8833 31.1667H30.7C31.0967 31.1667 31.2951 31.1667 31.4466 31.0895C31.5799 31.0216 31.6882 30.9132 31.7561 30.78C31.8333 30.6284 31.8333 30.4301 31.8333 30.0334V25.2167C31.8333 24.82 31.8333 24.6217 31.7561 24.4701C31.6882 24.3368 31.5799 24.2285 31.4466 24.1606C31.2951 24.0834 31.0967 24.0834 30.7 24.0834H25.8833C25.4866 24.0834 25.2883 24.0834 25.1368 24.1606C25.0035 24.2285 24.8951 24.3368 24.8272 24.4701C24.75 24.6217 24.75 24.82 24.75 25.2167V30.0334C24.75 30.4301 24.75 30.6284 24.8272 30.78C24.8951 30.9132 25.0035 31.0216 25.1368 31.0895C25.2883 31.1667 25.4866 31.1667 25.8833 31.1667ZM4.63333 9.91671H9.45C9.8467 9.91671 10.0451 9.91671 10.1966 9.8395C10.3299 9.77159 10.4382 9.66323 10.5061 9.52995C10.5833 9.37843 10.5833 9.18008 10.5833 8.78337V3.96671C10.5833 3.57 10.5833 3.37165 10.5061 3.22013C10.4382 3.08685 10.3299 2.97849 10.1966 2.91058C10.0451 2.83337 9.8467 2.83337 9.45 2.83337H4.63333C4.23663 2.83337 4.03828 2.83337 3.88676 2.91058C3.75348 2.97849 3.64511 3.08685 3.5772 3.22013C3.5 3.37165 3.5 3.57 3.5 3.96671V8.78337C3.5 9.18008 3.5 9.37843 3.5772 9.52995C3.64511 9.66323 3.75348 9.77159 3.88676 9.8395C4.03828 9.91671 4.23663 9.91671 4.63333 9.91671Z"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">TooShare</span>
          </a>
        </li>

        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Ressources
        </li>
        <li>
          <a
            [routerLink]="['/dashboard/bibliotheque']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 18"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M10 16.5c0-1-8-2.7-9-2V1.8c1-1 9 .707 9 1.706M10 16.5V3.506M10 16.5c0-1 8-2.7 9-2V1.8c-1-1-9 .707-9 1.706"
              />
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">Bibliothèque</span>
          </a>
        </li>
        <li class="mb-4">
          <a
            [routerLink]="['tutos']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="67"
              height="66"
              viewBox="0 0 67 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="youtube">
                <g id="Icon">
                  <path
                    d="M59.6816 19.7997C59.3847 18.6133 58.7799 17.5262 57.9284 16.6484C57.0768 15.7705 56.0087 15.1329 54.8319 14.7999C50.5321 13.75 33.333 13.75 33.333 13.75C33.333 13.75 16.1339 13.75 11.8341 14.8999C10.6573 15.2329 9.58919 15.8705 8.73765 16.7484C7.88612 17.6262 7.28133 18.7133 6.98438 19.8997C6.19745 24.2633 5.81253 28.69 5.83444 33.124C5.80639 37.5914 6.19134 42.0518 6.98438 46.4483C7.31176 47.5979 7.93009 48.6436 8.77964 49.4843C9.62919 50.3251 10.6812 50.9326 11.8341 51.2481C16.1339 52.398 33.333 52.398 33.333 52.398C33.333 52.398 50.5321 52.398 54.8319 51.2481C56.0087 50.9151 57.0768 50.2775 57.9284 49.3996C58.7799 48.5218 59.3847 47.4347 59.6816 46.2483C60.4625 41.9175 60.8474 37.5246 60.8316 33.124C60.8596 28.6566 60.4747 24.1962 59.6816 19.7997Z"
                    stroke="#ffffff"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M27.1455 26.0297C27.1455 24.7171 27.1455 24.0609 27.4198 23.6945C27.6588 23.3752 28.0247 23.1754 28.4226 23.147C28.8791 23.1144 29.4311 23.4693 30.5352 24.1791L41.3779 31.1494C42.336 31.7653 42.815 32.0733 42.9805 32.4648C43.125 32.807 43.125 33.193 42.9805 33.5352C42.815 33.9267 42.336 34.2347 41.3779 34.8506L30.5352 41.8209C29.4311 42.5307 28.8791 42.8856 28.4226 42.853C28.0247 42.8246 27.6588 42.6248 27.4198 42.3055C27.1455 41.9391 27.1455 41.2829 27.1455 39.9703V26.0297Z"
                    stroke="#ffffff"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">Tutos</span>
          </a>
        </li>
        <div class="mb-4">
          <li class="uppercase text-greyLighter text-sm font-bold mb-1">
            Plateforme LMS
          </li>
          <!-- Moodle science -->
          <li>
            <a
              class="nav_item"
              routerLinkActive="active-link"
              [href]="urlPlateformeScience"
              target="_blank"
              ><svg
                height="24"
                id="svg8"
                version="1.1"
                viewBox="0 0 24 24"
                width="24"
              >
                <g
                  id="g1514"
                  style="display: inline"
                  transform="translate(-0.0011279,-290.64853)"
                >
                  <path
                    fill="#E5E8EC"
                    d="m 2.31126,305.45171 a 1.0001,1.0001 0 0 0 -0.2928,0.71263 l 0.0345,5.48974 a 1.0001,1.0001 0 0 0 1.00697,0.99283 l 5.42206,-0.0359 a 1.0001,1.0001 0 0 0 0.70019,-0.2914 l 11.76119,-11.76119 c 1.38704,-1.387 1.38747,-3.6622 0,-5.04918 l -1.81887,-1.81886 c -1.38708,-1.387 -3.66487,-1.387 -5.05195,-1e-5 z m 1.70976,1.11866 8.09168,-8.09168 4.04099,4.04102 -8.09442,8.09442 -4.01202,0.0262 z m 9.50588,-9.50588 1.95975,-1.95975 c 0.62801,-0.628 1.59549,-0.62798 2.2235,1e-5 l 1.81887,1.81887 c 0.62805,0.62798 0.62768,1.59273 10e-6,2.22075 l -1.96112,1.96112 z"
                  />
                </g>
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Science</span>
            </a>
          </li>
          <!-- <li>
            <button class="nav_item text-left" (click)="openUrl(urlScholarVox)">
              <svg
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                style="transform: scale(1.1)"
              >
                <path
                  fill="#E5E8EC"
                  d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                />
              </svg>
              <span>Scholar Vox</span>
            </button>
          </li> -->
        </div>
        <!-- Moodle science -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Opportunités
        </li>
        <li>
          <a
            [routerLink]="['tableau-bord']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="announcement-02">
                <path
                  id="Icon"
                  d="M4 14L5.57465 20.2986C5.61893 20.4757 5.64107 20.5643 5.66727 20.6416C5.92317 21.3971 6.60352 21.9283 7.39852 21.9933C7.4799 22 7.5712 22 7.75379 22C7.98244 22 8.09677 22 8.19308 21.9907C9.145 21.8983 9.89834 21.145 9.99066 20.1931C10 20.0968 10 19.9824 10 19.7538V5.5M18.5 13.5C20.433 13.5 22 11.933 22 10C22 8.06701 20.433 6.5 18.5 6.5M10.25 5.5H6.5C4.01472 5.5 2 7.51472 2 10C2 12.4853 4.01472 14.5 6.5 14.5H10.25C12.0164 14.5 14.1772 15.4469 15.8443 16.3556C16.8168 16.8858 17.3031 17.1509 17.6216 17.1119C17.9169 17.0757 18.1402 16.9431 18.3133 16.7011C18.5 16.4402 18.5 15.918 18.5 14.8737V5.12629C18.5 4.082 18.5 3.55985 18.3133 3.29889C18.1402 3.0569 17.9169 2.9243 17.6216 2.88813C17.3031 2.84912 16.8168 3.1142 15.8443 3.64436C14.1772 4.55312 12.0164 5.5 10.25 5.5Z"
                  stroke="#fff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">Actus & Offres</span>
          </a>
        </li>
      </div>
      <!-- AMI -->
      <!-- <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
        <li>
          <a [routerLink]="['ami/activiteami']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <circle cx="3" cy="6" r="1.5" />
              <circle cx="3" cy="12" r="1.5" />
              <circle cx="3" cy="18" r="1.5" />
            </svg>
            <span class="ml-3">Activités mensuelles</span>
          </a>
        </li>
      </div> -->
    </ul>
  </div>
</div>
